import React, { useState, useEffect } from "react";
import { Card, CardBody } from "reactstrap";
import { useSelector } from "react-redux";

import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import { isFilterApplied } from "views/pages/manage/unAssigned/studentFinanceApproval/epmrCancellation/constant.js";

import { DEFAULT_FILTER_STATE } from "./helper";
import { getCourseIds } from "./utilsFunctions";

const Filters = ({
  closeForm,
  applyFilters,
  filters,
  setFilterCount,
  filterCount,
}) => {
  const masterDropdowns = useSelector(
    (state) => state.globalData.masterDropdowns
  );

  const [courseIdOptions, setCourseIdOptions] = useState([]);

  const [filterForm, setFilterForm] = useState({
    ...filters,
    courseId: filters?.searchBy === "courseId" ? filters.searchByValue : "",
  });

  const {
    academicCareer,
    classes,
    attribute,
    language,
    courseId,
    board,
    stream,
  } = filterForm;

  useEffect(() => {
    if (
      academicCareer?.length &&
      classes?.length &&
      attribute?.length &&
      language?.length
    ) {
      fetchCourseIdOptions();
    } else setCourseIdOptions([]);
  }, [academicCareer, classes, attribute, language]);

  const fetchCourseIdOptions = async () => {
    const apiResponse = await getCourseIds({
      languageId: language.map((item) => item.value),
      academicCareerId: academicCareer.map((item) => item.value),
      attribute: attribute.map((item) => item.value),
      classId: classes.map((item) => item.value),
      // boardId: [board?.value] || null,
      // academicGroupId: [stream?.value] || null,
    });

    setCourseIdOptions(apiResponse);
    filterFormHandler("", "courseId");
  };

  const handleApplyFilter = () => {
    if (filterForm?.["searchBy"]) delete filterForm.searchBy;
    if (filterForm?.["searchByValue"]) delete filterForm.searchByValue;

    const filterCount = isFilterApplied(filterForm);
    setFilterCount(filterCount);

    applyFilters(filterForm);
    closeForm();
  };

  const resetFilterForm = () => {
    setFilterForm({ ...DEFAULT_FILTER_STATE, courseId: "" });
    applyFilters(DEFAULT_FILTER_STATE);

    setFilterCount(0);
    closeForm();
  };

  const filterFormHandler = (value, key) => {
    setFilterForm((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <Card
      className="mb-0 regular-body label-color"
      style={{ width: "330px", borderRadius: "12px" }}
    >
      <CardBody className="d-flex flex-column">
        <div className="text-bold text-lg mb-2">Filters</div>

        <div className="d-flex flex-column gap-md">
          <AAutoComplete
            label="Career"
            placeholder="Select"
            items={masterDropdowns.academicCareer}
            currentValue={academicCareer}
            isShowCount={true}
            isMulti={true}
            handleChange={(value) => {
              filterFormHandler(value, "academicCareer");
            }}
            inputKey="academicCareer"
          />

          <AAutoComplete
            label="Class"
            placeholder="Select"
            items={masterDropdowns.classes}
            isShowCount={true}
            isMulti={true}
            currentValue={classes}
            handleChange={(value) => {
              filterFormHandler(value, "classes");
            }}
            inputKey="classes"
          />

          <AAutoComplete
            label="Attribute"
            placeholder="Select"
            items={masterDropdowns.attribute}
            isShowCount={true}
            isMulti={true}
            currentValue={attribute}
            handleChange={(value) => {
              filterFormHandler(value, "attribute");
            }}
            inputKey="attribute"
          />
          <AAutoComplete
            label="Language"
            placeholder="Select"
            items={masterDropdowns.languages}
            isShowCount={true}
            isMulti={true}
            currentValue={language}
            handleChange={(value) => {
              filterFormHandler(value, "language");
            }}
            inputKey="language"
          />

          <AAutoComplete
            label="Course ID"
            currentValue={courseId}
            handleChange={(value) => {
              filterFormHandler(value, "courseId");
            }}
            items={courseIdOptions}
            placeholder="Search by Course ID or description"
            isShowCount={false}
            isMulti={false}
            inputKey="courseId"
            isDisabled={
              !academicCareer.length ||
              !language.length ||
              !classes.length ||
              !attribute.length
            }
          />

          <AAutoComplete
            label="Board"
            currentValue={board}
            handleChange={(value) => {
              filterFormHandler(value, "board");
            }}
            items={masterDropdowns.board}
            isShowCount={false}
            isMulti={false}
            inputKey="board"
          />

          <AAutoComplete
            label="Stream"
            currentValue={stream}
            handleChange={(value) => {
              filterFormHandler(value, "stream");
            }}
            items={masterDropdowns.stream}
            isShowCount={false}
            isMulti={false}
            inputKey="stream"
          />

          <div className="mt-3 d-flex flex-row-reverse">
            <AButton
              variant="primary_filled"
              className="w-full"
              onClick={handleApplyFilter}
              disabled={
                !academicCareer.length &&
                !language.length &&
                !classes.length &&
                !attribute.length &&
                !board &&
                !stream &&
                !courseId
              }
            >
              Apply filter
            </AButton>

            {filterCount > 0 && (
              <AButton
                variant="outline"
                className="button_remove_left_margin"
                updatedStyle={{ border: "1px solid #CC5F5F", color: "#CC5F5F" }}
                onClick={resetFilterForm}
              >
                Reset
              </AButton>
            )}
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default Filters;
